import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { FeatureToggleName } from 'src/app/model/feature-toggle-name.model';
import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import {
  AppButtonComponent,
} from '@ifaa-components/ui-components';
import { TranslatePipe } from '@ngx-translate/core';
import { AppComponentWrapperComponent } from 'src/app/modules/shared/components/app-component-wrapper/app-component-wrapper.component';
import { MemberViewComponent } from 'src/app/modules/shared/components/member-view/member-view.component';
import { FeatureToggleDirective } from 'src/app/modules/shared/directives/feature-toggle.directive';
import { ComponentBase } from 'src/app/views/component-base';
import { AppState } from 'src/app/store/app.states';
import { memberAccountDropdown_SelectedAccount } from '../member-account-dropdown/selectors';
import { distinctUntilChanged } from 'rxjs';
import { PersonalDetailsRequestAction } from './actions';
import { personalDetails_Wording } from './selectors';
import { MessagePipe } from '../../pipes/message';
import { BannerComponent } from '../banner/banner.component';

@Component({
  selector: 'app-personal-details',
  templateUrl: './personal-details.component.html',
  styleUrls: ['./personal-details.component.scss'],
  host: {
    class: 'w-100',
  },
  imports: [
    AppComponentWrapperComponent,
    AsyncPipe,
    FeatureToggleDirective,
    MemberViewComponent,
    NgClass,
    AppButtonComponent,
    TranslatePipe,
    MessagePipe,
    BannerComponent,
    NgIf
  ],
})
export class PersonalDetailsComponent
  extends ComponentBase
  implements OnInit, OnDestroy {

  personalDetailsBeneficiaryFeatureToggle =
    FeatureToggleName.member.personalDetails.beneficiaries.view;
  updatePersonalDetailsFeatureToggle =
    FeatureToggleName.member.personalDetails.update;

  selectedAccount$ = this.store.pipe(select(memberAccountDropdown_SelectedAccount));
  wording$ = this.store.pipe(select(personalDetails_Wording));

  constructor(public store: Store<AppState>, private router: Router) {
    super();
  }

  ngOnInit() {
    super.ngOnInitBase();

    this.sub = this.selectedAccount$.pipe(distinctUntilChanged((x, y) => JSON.stringify(x) === JSON.stringify(y)))
      .subscribe(x => {
        if (x) {
          this.store.dispatch(PersonalDetailsRequestAction({ accountId: x.accountId }))
        }
      })
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }

  onMemberEditClick() {
    this.router.navigate(['personal-edit']);
  }
}
